import z from 'zod'
import { createFileRoute } from '@tanstack/react-router'
import { ExtructCompanies } from '@/features/extruct-companies'

const searchSchema = z.object({
  page: z.number().optional().catch(1),
  pageSize: z.number().optional().catch(50),
  filter: z.string().optional().catch(''),
  linkedStatus: z.enum(['all', 'linked', 'unlinked']).optional().catch(undefined),
  companyId: z.string().optional(),
})

export const Route = createFileRoute('/_authenticated/extruct-companies/')({
  validateSearch: searchSchema,
  component: ExtructCompanies,
})
